import { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { EErrorMsg } from '../../../commons/statics/controls';
import enviroment from '../../../enviroments/enviroment';
import { AppContext } from '../../../commons/context/App-context';
import IconCheck from '../../../images/check-green.svg';
import IconError from '../../../images/error.svg';
import './validated.scss';

const Validated = () => {
    const { isLoading, changeIsLoading } = useContext(AppContext);
    const [msgError, setMsgError] = useState<string>('');
    const [start] = useState<boolean>(false);

    const handleBackLanding = () => {
        window.open('https://rpp.pe/empresasquetransforman', '_self');
    };

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const hash = params.get('hash') || '';

        changeIsLoading(true);
        setMsgError('');
        axios
            .get(enviroment.apiURL + '/user/activation/' + hash)
            .then((res: any) => {
                const { err } = res?.data || {};
                changeIsLoading(false);
                if (err) {
                    setMsgError(err);
                } else {
                    setMsgError('');
                }
            })
            .catch(() => {
                changeIsLoading(false);
                setMsgError(EErrorMsg.generic);
            });
    }, [start]);

    return (
        <div className="ValidatedWrapFull">
            <div className="ValidatedLogo">
                <img
                    alt="Empresas que transforman el Perú"
                    src="/images/logo.png"
                    onClick={handleBackLanding}
                />
            </div>
            <div className="ValidatedWrap">
                <div className="ValidatedWrapInner">
                    {!isLoading && (
                        <>
                            <img
                                src={msgError ? IconError : IconCheck}
                                alt=""
                            />
                            {msgError ? (
                                <>
                                    <h4 className="ValidatedTitle">
                                        {msgError}
                                    </h4>
                                    <p>&nbsp;</p>
                                </>
                            ) : (
                                <>
                                    <h4 className="ValidatedTitle">
                                        ¡Felicidades, tu cuenta ha sido
                                        validada!
                                    </h4>
                                    <p className="mb2">
                                        Bienvenido a postular a la Lista de
                                        Empresas que Transforman el Perú
                                    </p>
                                </>
                            )}

                            <Link className="button buttonAuto" to="/signin">
                                Iniciar sesión
                            </Link>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Validated;
